module.exports = __webpack_public_path__ + "static/img/irole.a53c1c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/role3/yjyx/irole.png
// module id = 0VG7
// module chunks = 7